import BarChartIcon from '@mui/icons-material/BarChart';

const basePath = '/governanceroom/dashboardproductivity';

const buildMenu = (title, path) => ({
    title,
    icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
    path: `${basePath}/${path}`,
    gap: true
});

export const menus = [
    buildMenu('Presos Apreendidos', 'prisioners'),
    buildMenu('Veículos Recuperados', 'recovered-vehicles'),
    buildMenu('Armas de Fogo Apreendidas', 'weapons'),
    buildMenu('Entorpecentes em gramas', 'narcotic-quantities'),
    buildMenu('Entorpecentes', 'narcotics'),
    buildMenu('Flagrantes Lavrados', 'arrests-made'),
    buildMenu('Art. 173 - ECA', 'art173eca')
];
